import storage from "redux-persist/lib/storage";
import { encryptTransform } from "redux-persist-transform-encrypt";

const ENCRYPTION_KEY =
  process.env.REACT_APP_PERSIST_KEY || "mySuperSecretKey123!";

export const persistSchool = {
  key: "school",
  storage,
  whitelist: ["currentStream"], // ✅ SEUL currentStream est persisté
  transforms: [
    encryptTransform({
      secretKey: ENCRYPTION_KEY,
      onError: (err) => {
        console.error("Erreur de déchiffrement schoolSlice :", err);
      },
    }),
  ],
};
